import { Spinner, Box } from "@chakra-ui/react";
import { FunctionComponent } from 'react';

export const LoadingPage: FunctionComponent = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={1000}
      backgroundColor="var(--chakra-colors-chakra-body-bg)"
    >
      <Spinner color="gray.400" size="xl" />
    </Box>
  );
};

export default LoadingPage;
